/*
 * @Author: qiaoshiteng
 * @Date: 2023-05-11 08:51:20
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-03-25 17:09:52
 * @Description:
 */

const DEFAULT_CONFIG = {
	//标题
	APP_NAME: process.env.VUE_APP_TITLE,
	COMPANY_NAME: "北京东进航空科技股份有限公司©",

	//首页地址
	DASHBOARD_URL: "/mail/receiveBox",

	//版本号
	APP_VER: "1.6.6",

	//内核版本号
	CORE_VER: "1.6.6",

	//主服务接口地址
	MAIN_URL: "/mainApi",
	HNYJ_URL: "/hnyjApi",
	LSS_URL: "/lssApi",
	//新版服务站（galss）接口地址：服务端已全局放开 CORS，前端直接跨域调用
	GALSS_URL: "https://hn-df.gafuwu.cn:9443/test_galss_hn",

	//飞参——飞机模型地址（地址前缀）
	FLY_MODLE_URL: "https://dj-aers-gaefb.oss-cn-beijing.aliyuncs.com/dj-aers-gaefb-shoudong",

	//主服务上传地址
	UPLOAD_URL: "/uploadApi",
	//NAIP接口地址
	NAIP_URL: "/naipApi",
	//ADSB接口地址
	ADSB_URL: "/adsbApi",
	LIVE_URL: "/liveApi",
	GAIO_URL: "/gaioApi",
	NEWNAIP_URL: "/newNaipApi",
	//WebSocket接口地址
	// WS_URL: "ws://192.168.181.240:7888/adsb/ws",  //本地
	// WS_URL: "ws://101.201.100.220:8081/adsb/ws",	 //测试
	WS_URL: "wss://www.gaeac.com/adsb/ws",	 //大庆

	// WS_URL_BH:'ws://101.201.100.220:8081/gaefb/websocketServer/cooTask',
	// WS_URL_BH:'ws://10.0.31.226:8001/gaefb/websocketServer',
	WS_URL_BH: 'ws://192.168.10.121:8888/gaefb/websocketServer/cooTask',
	// WS_URL_BH: 'wss://www.gaeac.com/mutualEfb/websocketServer/cooTask',

	// 版本号控制 偶数代表成熟版 奇数抢先版
	VERSION_NUM: "3.1.2",
	//请求超时
	TIMEOUT: 1000000,

	//TokenName
	TOKEN_NAME: "token",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "",

	//追加其他头
	HEADERS: {},

	//请求是否开启缓存
	REQUEST_CACHE: false,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: 'header',

	//菜单是否折叠
	MENU_IS_COLLAPSE: false,

	//菜单是否启用手风琴效果
	MENU_UNIQUE_OPENED: false,

	//是否开启多标签
	LAYOUT_TAGS: false,

	//语言
	LANG: 'zh-cn',

	//主题颜色
	COLOR: '',

	//是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
	LS_ENCRYPTION: '',

	//localStorageAES加密秘钥，位数建议填写8的倍数
	LS_ENCRYPTION_key: '2XNN4K8LC0ELVWN4',

	//控制台首页默认布局
	DEFAULT_GRID: {
		//默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
		layout: [12, 6, 6],
		//小组件分布，com取值:views/home/components 文件名
		copmsList: [
			['welcome'],
			['about', 'ver'],
			['time', 'progress']
		]
	}
}

//合并业务配置
import MY_CONFIG from "./myConfig"
Object.assign(DEFAULT_CONFIG, MY_CONFIG)

// 如果生产模式，就合并动态的APP_CONFIG
// public/config.js
if (process.env.NODE_ENV === 'production') {
	Object.assign(DEFAULT_CONFIG, APP_CONFIG)
}

export default DEFAULT_CONFIG
